import * as React from 'react'
import CruiseShipCheckboxGroup
  from 'components/Cruises/SearchPage/Filters/Inputs/CruiseShipCheckboxGroup/CruiseShipCheckboxGroup'

interface Props {
  cruiseShips?: Set<string>
  onChange: (nextFilters: React.ChangeEvent<HTMLInputElement>) => void
  shipNameFacets: Array<App.ShipNameFacetV2Item>
  fetching?: boolean
}

function CruiseShipFilter({
  cruiseShips,
  onChange,
  shipNameFacets,
  fetching,
}: Props) {
  return <CruiseShipCheckboxGroup
    shipItems={shipNameFacets}
    onChange={onChange}
    defaultSelected={cruiseShips}
    fetching={fetching}
  />
}

export default CruiseShipFilter
